import { PriceLayer } from "./entity";
import DtoList from "../../base_classes/dto_list";
import { type JSONData } from "../../base_classes/dto.d";
import { type IPriceLayerList } from "./list.gen.d";
import { Pagination } from "../../base_classes/pagination";
import { Query } from "../../base_classes/query";

/// ///////////////////////////////////////////////////////////////////////////////////////////////////
/// WARNING! THIS FILE IS AUTOMATICALLY GENERATED, ANY CHANGES WILL BE LOST ON NEXT GENERATION
/// ///////////////////////////////////////////////////////////////////////////////////////////////////

export class PriceLayerList extends DtoList implements IPriceLayerList {
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////
  _path = "/price_layer";

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////
  list: PriceLayer[] = [];
  queriedList: PriceLayer[] = [];

  /// ///////////////////////////////////////
  /// ////////////// METHODS ////////////////
  /// ///////////////////////////////////////

  _buildInstance(data: JSONData): PriceLayer {
    return new PriceLayer([], data);
  }

  override async getAll(
    pathVars?: string | string[] | Record<string, string>,
  ): Promise<PriceLayer[]> {
    return (await super.getAll(pathVars)) as PriceLayer[];
  }

  override async getPaginated(
    pathVars: string | string[],
    pagination: Pagination,
  ): Promise<{
    items: PriceLayer[];
    pagination: Pagination;
  }> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return (await super.getPaginated(pathVars, pagination)) as {
      items: PriceLayer[];
      pagination: Pagination;
    };
  }

  override async query(
    queries: Query[],
    pagination?: Pagination,
  ): Promise<{
    items: PriceLayer[];
    pagination: Pagination;
  }> {
    return (await super.query(queries, pagination)) as {
      items: PriceLayer[];
      pagination: Pagination;
    };
  }

  override async search(
    query: string,
    pagination?: Pagination,
  ): Promise<{
    items: PriceLayer[];
    pagination: Pagination;
  }> {
    return (await super.search(query, pagination)) as {
      items: PriceLayer[];
      pagination: Pagination;
    };
  }
}
